import React from 'react';
import { useField } from 'formik';
import { clsx } from 'clsx';

export default function SelectField({ label, options, ...props }) {
  const [field, meta] = useField(props);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <select
        {...field}
        {...props}
        className={clsx(
          'mt-1 block w-full rounded-md shadow-sm',
          'border-gray-300 focus:border-indigo-500 focus:ring-indigo-500',
          { 'border-red-300': meta.touched && meta.error }
        )}
      >
        <option value="">Select {label}</option>
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      {meta.touched && meta.error ? (
        <div className="mt-1 text-sm text-red-600">{meta.error}</div>
      ) : null}
    </div>
  );
}